import { createFileRoute } from "@tanstack/react-router";
import { GroupsPage } from "../-rules/groups.page";

export const Route = createFileRoute("/content/rules/groups/")({
  component: GroupsPage,
});
